import Alert from 'src/languages/en/Alert.json';
import Button from 'src/languages/en/Button.json';
import CardHeader from 'src/languages/en/CardHeader.json';
import Field from 'src/languages/en/Field.json';
import Link from 'src/languages/en/Link.json';
import LoadingButton from 'src/languages/en/LoadingButton.json';
import Page from 'src/languages/en/Page.json';
import SnackbarMessage from 'src/languages/en/SnackbarMessage.json';
import StepLabel from 'src/languages/en/StepLabel.json';
import Tab from 'src/languages/en/Tab.json';
import Typography from 'src/languages/en/Typography.json';
import Tooltip from 'src/languages/en/Tooltip.json';
import DataGrid from 'src/languages/en/DataGrid.json';
import Autocomplete from 'src/languages/en/Autocomplete.json';
import MenuItem from 'src/languages/en/MenuItem.json';
import DialogTitle from 'src/languages/en/DialogTitle.json';
import FormLabel from 'src/languages/en/FormLabel.json';
import Checkboxes from 'src/languages/en/Checkboxes.json';
import Radios from 'src/languages/en/Radios.json';
import TextField from 'src/languages/en/TextField.json';
import TableCell from 'src/languages/en/TableCell.json';
import PropertyListItem from 'src/languages/en/PropertyListItem.json';

const result = {
  ...Alert,
  ...Button,
  ...CardHeader,
  ...Field,
  ...Link,
  ...LoadingButton,
  ...Page,
  ...SnackbarMessage,
  ...StepLabel,
  ...Tab,
  ...Typography,
  ...Tooltip,
  ...DataGrid,
  ...Autocomplete,
  ...MenuItem,
  ...DialogTitle,
  ...FormLabel,
  ...Checkboxes,
  ...Radios,
  ...TextField,
  ...TableCell,
  ...PropertyListItem
};

export default result;
